import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importOverpaymentResolvedSuccess = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "OverpaymentResolvedSuccess" */
                '@perpay-web/fintech/components/screens/OverpaymentResolvedSuccess/OverpaymentResolvedSuccess'
            ),
    );

export const importUserInitiatedWithdrawalSuccess = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "UserInitiatedWithdrawalSuccess" */
                '@perpay-web/fintech/components/screens/WithdrawalSuccess/WithdrawalSuccess'
            ),
    );
